import React, {
  useEffect,
  useState,
  useRef,
  forwardRef,
  useImperativeHandle
} from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import InfoIcon from '@material-ui/icons/Info'
import abbreviate from 'abbreviate-name'
import { useAbility } from '../Usuarios'
import { getListActions } from '../../lib/crudAuthorization'
import { Button, Tooltip } from '@material-ui/core'
import moment from 'moment'
import { List, useListRepository, Snackbar } from 'elentari'
import { getUsuarioId } from '../../utils/Utils'
import minhasTarefasRepository from './minhasTarefasRepository'
import { TarefaBadgeStatus, TarefaStatusEnum } from './TarefaStatus'
import TarefaAnalistaFilter from './Filters/TarefaAnalistaFilter'
import { formatNomeUsuario } from '../../utils/Formatter'

const THIRTY_SECONDS = 1000 * 30
const useStyles = makeStyles(theme => ({
  header: {
    padding: theme.spacing(2)
  }
}))

const TarefasEstatisticas = forwardRef((props, ref) => {
  const [quantidadeFila, setQuantidadeFila] = useState(0)
  const [quantidadeFilaAnalista, setQuantidadeFilaAnalista] = useState(0)

  const fetchData = async () => {
    const or = [
      { status: TarefaStatusEnum.ABERTO },
      { status: TarefaStatusEnum.REABERTO },
      { status: TarefaStatusEnum.STANDBY }
    ]
    const where = {
      or
    }
    const whereAnalista = {
      and: [{ or }, { responsavelId: getUsuarioId() }]
    }
    const [response, responseAnalista] = await Promise.all([
      minhasTarefasRepository.count(where),
      minhasTarefasRepository.count(whereAnalista)
    ])
    if (response.ok) {
      setQuantidadeFila(response.data.count)
    }
    if (responseAnalista.ok) {
      setQuantidadeFilaAnalista(responseAnalista.data.count)
    }
  }

  useImperativeHandle(ref, () => ({
    update: () => {
      fetchData()
    }
  }))

  useEffect(() => {
    fetchData()
    const interval = setInterval(() => fetchData(), THIRTY_SECONDS)
    return () => clearInterval(interval)
  }, [])

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
      spacing={2}
    >
      <Grid item sm={4} xs={12}>
        Quantidade na fila: {quantidadeFila}
        {quantidadeFila > 0 && (
          <Tooltip
            placement="top"
            title="Algumas tarefas podem estar exclusivas para analistas"
          >
            <InfoIcon fontSize="small" />
          </Tooltip>
        )}
      </Grid>
      <Grid item sm={4} xs={12}>
        Minhas tarefas na fila: {quantidadeFilaAnalista}
      </Grid>
    </Grid>
  )
})

const TarefasAnalista = ({ history, ...props }) => {
  const [ability] = useAbility()
  const classes = useStyles()
  const [mensagem, setMensagem] = useState()
  const refEstatisticas = useRef(null)

  const listHook = useListRepository({
    repository: minhasTarefasRepository,
    defaultSort: 'createdAt desc'
  })

  useEffect(() => {
    const interval = setInterval(() => listHook.fetchList(), THIRTY_SECONDS)
    return () => clearInterval(interval)
  }, [listHook])

  const listOptions = {
    defaultOrder: 'createdAt desc',
    fields: {
      id: {
        label: 'Id'
      },
      createdAt: {
        label: 'Data Criação',
        format: data => moment(data).format('DD/MM/YYYY HH:mm'),
        align: 'center'
      },
      responsavel: {
        label: 'Responsável',
        format: data => abbreviate(data ? data.nome : '')
      },
      ordemCarregamento: {
        label: 'Ordem de Carregamento'
      },
      cpfMotorista: {
        label: 'CPF'
      },
      placaCavalo: {
        label: 'Placa'
      },
      status: {
        label: 'Status',
        format: value => <TarefaBadgeStatus status={value} />
      },
      dataTermino: {
        label: 'Data de Término',
        format: data => (data ? moment(data).format('DD/MM/YYYY HH:mm') : '-')
      },
      embarcador: {
        label: 'Embarcador',
        format: formatNomeUsuario,
        noOrder: true
      },
      centroCusto: {
        label: 'Centro de Custo',
        format: centroCusto => (centroCusto ? centroCusto.descricao : '-'),
        noOrder: true
      },
      empresa: {
        label: 'Empresa',
        format: empresa => (empresa ? empresa.sigla : '-'),
        noOrder: true,
        align: 'center'
      }
    }
  }

  const handleProxima = async () => {
    const response = await minhasTarefasRepository.proxima()
    if (response.ok) {
      listHook.fetchList()
      refEstatisticas.current.update()
    } else {
      setMensagem(response.data.error.message)
    }
  }

  const actions = getListActions(ability, listHook, 'tarefasAnalista')

  return (
    <>
      <TarefaAnalistaFilter />
      <Paper className={classes.header}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Grid item lg={11} sm={8} xs={12}>
            <TarefasEstatisticas ref={refEstatisticas} />
          </Grid>
          <Grid item lg={1} sm={4} xs={12}>
            <Grid container direction="row" justifyContent="flex-end">
              <Button
                variant="contained"
                color="primary"
                onClick={handleProxima}
              >
                Próxima
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickNew={null}
        onClickEdit={null}
        onClickView={null}
        removeItem={null}
        onClickRow={item =>
          history.push(`/tarefasAnalista/${item.id}${history.location.search}`)
        }
        hideDownloadIcon
        listOptions={listOptions}
      />
      <Snackbar message={mensagem} onClose={() => setMensagem('')} />
    </>
  )
}

export default TarefasAnalista
